{
  "replaceMessage": "파일을 드롭하여 바꾸기"
}
